<div class="contact-cta-box">
  <h3>{{ questionTitle }}</h3>
  <p>{{ answerTitle }}</p>
  <a i18n="@@contactUsButton" [href]="contactLink" class="btn btn-primary">Contact Us</a>
</div>
